<h2 mat-dialog-title>Herkunftsbetrieb setzen</h2>

<mat-dialog-content class="dialog-content">
    <p>Es wird nur die Tierliste aktualisiert.</p>

    <section class="auswahl-section">
        <h3>Herkunft auswählen</h3>
        <kiene-betriebskontakt-auswahl
            [config]="{
                showLandwirte: true,
                showHaendler: true,
                showSchlachthoefe: true,
                showAll: true,
                multiSelect: false,
                compact: true,
                title: 'Herkunftsbetrieb auswählen',
                placeholder: 'Betrieb suchen...'
            }"
            [selectedKontakte]="selectedKontakt ? [selectedKontakt] : []"
            (kontaktSelected)="onKontaktSelected($event)"
            (kontakteSelected)="onKontakteSelected($event)"
        >
        </kiene-betriebskontakt-auswahl>
    </section>

    <section *ngIf="selectedKontakt" class="selected-card">
        <h4>Ausgewählter Betrieb</h4>
        <kiene-betriebskontakt-card
            [kontakt]="selectedKontakt"
            [config]="{
                showActions: false,
                showMenu: false,
                showFavorit: false,
                compact: true,
                showBadge: false,
                selectedMode: true
            }"
        >
        </kiene-betriebskontakt-card>
    </section>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()" [disabled]="isSaving">Abbrechen</button>
    <button mat-button color="warn" (click)="clearSelection()" [disabled]="isSaving">Herkunft entfernen</button>
    <button mat-flat-button color="primary" (click)="save()" [disabled]="isSaving">
        <mat-spinner *ngIf="isSaving" diameter="20"></mat-spinner>
        <span *ngIf="!isSaving">Speichern</span>
    </button>
</mat-dialog-actions>
